import React from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItem} from './AsideMenuItem'

function ZadMenuSection({id}: {id: string}) {
  const intl = useIntl()
  return (
    <div className='menu-item'>
      <div className='menu-content pt-8 pb-2'>
        <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
          {intl.formatMessage({id})}
        </span>
      </div>
    </div>
  )
}

export function AsideZadWorkspaceMenu({
  hasRoleAccess,
  showBackToMaarefati,
  maarefatiLandingPath,
}: {
  hasRoleAccess: (path: string) => boolean
  showBackToMaarefati: boolean
  maarefatiLandingPath: string
}) {
  const intl = useIntl()

  return (
    <>
      <ZadMenuSection id='ZAD.MENU.SECTION' />
      {showBackToMaarefati ? (
        <AsideMenuItem
          to={maarefatiLandingPath}
          icon='/media/icons/duotune/arrows/arr002.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.BACK_TO_MAAREFATI'})}
          fontIcon='bi-arrow-left'
          iconClassName='svg-icon-flip'
        />
      ) : null}
      {hasRoleAccess('/zad') ? (
        <AsideMenuItem
          to='/zad'
          icon='/media/icons/duotune/general/gen001.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.DASHBOARD'})}
          fontIcon='bi-speedometer2'
          exact
        />
      ) : null}

      <ZadMenuSection id='ZAD.MENU.GROUP_SALES' />
      {hasRoleAccess('/zad/sales') ? (
        <AsideMenuItem
          to='/zad/sales'
          icon='/media/icons/duotune/ecommerce/ecm002.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.SALES'})}
          fontIcon='bi-bag-check'
        />
      ) : null}
      {hasRoleAccess('/zad/sales-history') ? (
        <AsideMenuItem
          to='/zad/sales-history'
          icon='/media/icons/duotune/graphs/gra001.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.SALES_HISTORY'})}
          fontIcon='bi-clock-history'
        />
      ) : null}
      {hasRoleAccess('/zad/products') ? (
        <AsideMenuItem
          to='/zad/products'
          icon='/media/icons/duotune/ecommerce/ecm009.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.PRODUCTS'})}
          fontIcon='bi-box-seam'
        />
      ) : null}
      {hasRoleAccess('/zad/labels') ? (
        <AsideMenuItem
          to='/zad/labels'
          icon='/media/icons/duotune/general/gen005.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.LABELS'})}
          fontIcon='bi-upc-scan'
        />
      ) : null}
      {hasRoleAccess('/zad/catalogue') ? (
        <AsideMenuItem
          to='/zad/catalogue'
          icon='/media/icons/duotune/ecommerce/ecm001.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.CATALOGUE'})}
          fontIcon='bi-shop'
        />
      ) : null}
      {hasRoleAccess('/zad/promotions') ? (
        <AsideMenuItem
          to='/zad/promotions'
          icon='/media/icons/duotune/ecommerce/ecm004.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.PROMOTIONS'})}
          fontIcon='bi-tag'
        />
      ) : null}
      {hasRoleAccess('/zad/promo-codes') ? (
        <AsideMenuItem
          to='/zad/promo-codes'
          icon='/media/icons/duotune/general/gen028.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.PROMO_CODES'})}
          fontIcon='bi-upc'
        />
      ) : null}
      {hasRoleAccess('/zad/customers') ? (
        <AsideMenuItem
          to='/zad/customers'
          icon='/media/icons/duotune/communication/com014.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.CUSTOMERS'})}
          fontIcon='bi-people'
        />
      ) : null}
      {hasRoleAccess('/zad/customer-payments') ? (
        <AsideMenuItem
          to='/zad/customer-payments'
          icon='/media/icons/duotune/finance/fin008.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.CUSTOMER_PAYMENTS'})}
          fontIcon='bi-wallet2'
        />
      ) : null}

      <ZadMenuSection id='ZAD.MENU.GROUP_STOCK' />
      {hasRoleAccess('/zad/stock') ? (
        <AsideMenuItem
          to='/zad/stock'
          icon='/media/icons/duotune/ecommerce/ecm006.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.STOCK'})}
          fontIcon='bi-boxes'
          exact
        />
      ) : null}
      {hasRoleAccess('/zad/stock/replenishment') ? (
        <AsideMenuItem
          to='/zad/stock/replenishment'
          icon='/media/icons/duotune/ecommerce/ecm008.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.REPLENISHMENT'})}
          fontIcon='bi-arrow-repeat'
        />
      ) : null}
      {hasRoleAccess('/zad/procurement') ? (
        <AsideMenuItem
          to='/zad/procurement'
          icon='/media/icons/duotune/ecommerce/ecm008.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.PROCUREMENT'})}
          fontIcon='bi-clipboard-check'
        />
      ) : null}
      {hasRoleAccess('/zad/suppliers') ? (
        <AsideMenuItem
          to='/zad/suppliers'
          icon='/media/icons/duotune/ecommerce/ecm002.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.SUPPLIERS'})}
          fontIcon='bi-truck'
        />
      ) : null}
      {hasRoleAccess('/zad/purchases') ? (
        <AsideMenuItem
          to='/zad/purchases'
          icon='/media/icons/duotune/ecommerce/ecm008.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.PURCHASES'})}
          fontIcon='bi-cart-plus'
        />
      ) : null}
      {hasRoleAccess('/zad/supplier-payments') ? (
        <AsideMenuItem
          to='/zad/supplier-payments'
          icon='/media/icons/duotune/finance/fin002.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.SUPPLIER_PAYMENTS'})}
          fontIcon='bi-cash-stack'
        />
      ) : null}

      <ZadMenuSection id='ZAD.MENU.GROUP_AFTER_SALES' />
      {hasRoleAccess('/zad/customer-returns') ? (
        <AsideMenuItem
          to='/zad/customer-returns'
          icon='/media/icons/duotune/arrows/arr029.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.CUSTOMER_RETURNS'})}
          fontIcon='bi-arrow-return-left'
        />
      ) : null}
      {hasRoleAccess('/zad/customer-refunds') ? (
        <AsideMenuItem
          to='/zad/customer-refunds'
          icon='/media/icons/duotune/finance/fin001.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.CUSTOMER_REFUNDS'})}
          fontIcon='bi-cash-coin'
        />
      ) : null}

      <ZadMenuSection id='ZAD.MENU.GROUP_CATALOGUE' />
      {hasRoleAccess('/zad/categories') ? (
        <AsideMenuItem
          to='/zad/categories'
          icon='/media/icons/duotune/ecommerce/ecm001.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.CATEGORIES'})}
          fontIcon='bi-journal-bookmark'
        />
      ) : null}
      {hasRoleAccess('/zad/product-types') ? (
        <AsideMenuItem
          to='/zad/product-types'
          icon='/media/icons/duotune/general/gen025.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.PRODUCT_TYPES'})}
          fontIcon='bi-tags'
        />
      ) : null}

      <ZadMenuSection id='ZAD.MENU.GROUP_MANAGEMENT' />
      {hasRoleAccess('/zad/reports') ? (
        <AsideMenuItem
          to='/zad/reports'
          icon='/media/icons/duotune/graphs/gra001.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.REPORTS'})}
          fontIcon='bi-bar-chart'
        />
      ) : null}
      {hasRoleAccess('/zad/reports/accounting') ? (
        <AsideMenuItem
          to='/zad/reports/accounting'
          icon='/media/icons/duotune/finance/fin006.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.ACCOUNTING_REPORT'})}
          fontIcon='bi-journal-text'
        />
      ) : null}
      {hasRoleAccess('/zad/settings') ? (
        <AsideMenuItem
          to='/zad/settings'
          icon='/media/icons/duotune/coding/cod001.svg'
          title={intl.formatMessage({id: 'ZAD.MENU.SETTINGS'})}
          fontIcon='bi-gear'
        />
      ) : null}
    </>
  )
}
